var SaveMessages = /** @class */ (function () {
    function SaveMessages() {
        this.reset();
    }
    SaveMessages.prototype.reset = function () {
        this.saveFailed = false;
        this.saveSuccess = false;
        this._deleteSuccess = false;
        this._deleteFailed = false;
    };
    Object.defineProperty(SaveMessages.prototype, "deleteSuccess", {
        get: function () {
            return this._deleteSuccess;
        },
        set: function (v) {
            this._deleteSuccess = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaveMessages.prototype, "deleteFailed", {
        get: function () {
            return this._deleteFailed;
        },
        set: function (v) {
            this._deleteFailed = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaveMessages.prototype, "saveSuccess", {
        get: function () {
            return this._saveSuccess;
        },
        set: function (v) {
            this._saveSuccess = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaveMessages.prototype, "saveFailed", {
        get: function () {
            return this._saveFailed;
        },
        set: function (v) {
            this._saveFailed = v;
        },
        enumerable: true,
        configurable: true
    });
    return SaveMessages;
}());
export { SaveMessages };



// WEBPACK FOOTER //
// ./src/app/shared/models/save-messages.ts.pre-build-optimizer.js